import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FileText } from 'lucide-react';
import logger from '../../utils/logger';

/**
 * Récupère TOUS les formulaires actifs d'une catégorie, dans l'ordre défini
 * par l'administrateur (display_order géré via glisser-déposer dans le
 * Gestionnaire). Les icônes sont mappées par slug (iconMap) ; les nouveaux
 * formulaires reçoivent une icône par défaut. Ainsi l'ordre du Gestionnaire
 * se retrouve exactement sur la page Solutions du site.
 */
const useCategorySolutions = (category, iconMap = {}) => {
  const { i18n } = useTranslation();
  const [cards, setCards] = useState([]);
  const backendUrl = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const res = await fetch(`${backendUrl}/api/form-builder/public/forms?category=${encodeURIComponent(category)}`);
        if (!res.ok) return;
        const forms = await res.json();
        const isEn = i18n.language?.startsWith('en');
        const mapped = (forms || [])
          .filter(f => f.slug)
          .map(f => ({
            id: f.slug,
            slug: f.slug,
            title: (isEn && f.name_en) ? f.name_en : f.name,
            description: (isEn && f.description_en) ? f.description_en : (f.description || ''),
            icon: (iconMap[f.slug] && iconMap[f.slug].icon) || FileText,
            color: (iconMap[f.slug] && iconMap[f.slug].color) || 'text-brand-primary',
          }));
        if (!cancelled) setCards(mapped);
      } catch (e) {
        logger.error('useCategorySolutions load failed', e);
      }
    };
    load();
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [category, i18n.language]);

  return cards;
};

export default useCategorySolutions;
